import React from "react";
import Container from "../../../common/Container";
import banners from "../../../../mocks/banners";

import styles from "./vtb-banner.module.scss";

const createMarkup = (__html) => ({
  __html
});

export default function VTBBanner() {
  const {h1Text, regularTextHtml, image} = banners[`root`];

  const srcSet =
    image.length === 1
      ? false
      : image.map((url, index) => `${url} ${++index}x`).reverse();

  return (
    <div className={styles.root}>
      <Container className={styles.container}>
        <div className={styles.left}>
          <h1 className={styles.slogan}>{h1Text}</h1>
          <div
            className={styles.regularText}
            dangerouslySetInnerHTML={createMarkup(regularTextHtml)}
          />
        </div>
        <div className={styles.right}>
          <img loading="lazy"
            srcSet={srcSet}
            src={image[0]}
            alt={h1Text}
            className={styles.image}
          />
        </div>
      </Container>
    </div>
  );
}
